module.exports = __webpack_public_path__ + "img/bars-staggered.81ef33f4.svg";